/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect'
import { NAME } from './constants'

const getVirtualCardByBenefitId = createSelector(
  (state) => state[NAME],
  (vcs) => (benefitId) =>
    vcs.virtualCards.find((vc) => vc.benefitId === benefitId)
)

export { getVirtualCardByBenefitId }
